import { render, staticRenderFns } from "./Xsjladmin.vue?vue&type=template&id=6ad15743&scoped=true"
import script from "./Xsjladmin.vue?vue&type=script&lang=js"
export * from "./Xsjladmin.vue?vue&type=script&lang=js"
import style0 from "./Xsjladmin.vue?vue&type=style&index=0&id=6ad15743&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad15743",
  null
  
)

export default component.exports